const actionTypeIdentifier = '33D1B324-DEB7-4915-AB27-DBD79A032341'; // to generate open ssms run select newid()

//location form actions
export const setSubscriptionDetails = `SET-WIRELESS-CHANGE-USER-SUBSCRIPTION-DETAILS-${actionTypeIdentifier}`;
export const setNewUserDetails = `SET-WIRELESS-CHANGE-USER-NEW-USER-DETAILS-${actionTypeIdentifier}`;
export const setPurposeOptions = `SET-WIRELESS-CHANGE-USER-PURPOSE-OF-USE-OPTIONS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-WIRELESS-CHANGE-USER-FORM-SUBMITTED-${actionTypeIdentifier}`;
export const setBusinessCaseOptions = `SET-WIRELESS-CHANGE-USER-BUSINESS-CASE-OPTIONS-${actionTypeIdentifier}`;
export const setFormLoading = `SET-WIRELESS-CHANGE-USER-REQUEST-FORM-LOADING-${actionTypeIdentifier}`;
export const setResetLoading = `SET-WIRELESS-CHANGE-USER-REQUEST-RESET-LOADING-${actionTypeIdentifier}`;


export const wirelessChangeUserModel = {
    circuitCode: ''
    , circuitId: 0
    , employeeEmail: ''
    , employeeId: 0
    , purposeOfUseId: 0
    , purposeOfUse: ''
    , businessCase: ''
    , busJustiCodeDetailId: 0
    , businessJustification: ''
    , additionalInformation: ''
}
